"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _button = _interopRequireDefault(require("../button/button"));

var _classnames = _interopRequireDefault(require("classnames"));

var _popoverModule = _interopRequireDefault(require("./popover.module.css"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var Popover = function Popover(props) {
  var id = props.id,
      popover = props.popover,
      onPopoverLeave = props.onPopoverLeave;
  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_popoverModule.default['popover'], _popoverModule.default['right'])
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_arrow") : null,
    className: (0, _classnames.default)(_popoverModule.default["arrow"])
  }), _react.default.createElement("h3", {
    id: id ? "".concat(id, "_heading_3") : null,
    className: (0, _classnames.default)(_popoverModule.default["heading-3"], _popoverModule.default["popover-title"])
  }, popover.title ? popover.title : ''), _react.default.createElement("div", {
    id: id ? "".concat(id, "_content") : null,
    className: (0, _classnames.default)(_popoverModule.default["popover-content"])
  }, popover && popover.content ? popover.content : '', _react.default.createElement(_button.default, {
    id: id ? "".concat(id, "_btn_quaternary") : null,
    variant: 'quaternary',
    label: _react.default.createElement(_react.Fragment, null, "\xD7", popover && popover.closeLabel ? popover.closeLabel : " No"),
    onClick: onPopoverLeave
  })));
};

var _default = Popover;
exports.default = _default;
Popover.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Object that must contain all the required props of the selected popover component*/
  popover: _propTypes.default.object.isRequired
};